<div class="custom-slider">
    <input type="range" min="0.00" max="1.00" step="0.01" [value]="value" (input)="onInputChange($event.target)"
        class="sliderRange" [disabled]="disablePrompt" />
    <div class="indicator-container" [style.left]="labelPosition" *ngIf="showIndicator">
        <input type="number" min="0.00" max="1.00" step="0.01" [(ngModel)]="value" (keyup)="handleKeydown($event)"
            (input)="onInputChange($event.target)" class="indicator-input" [disabled]="disablePrompt">
    </div>
</div>